import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import Drawer from '@mui/material/Drawer'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import Fade from '@mui/material/Fade'
import Box from '@mui/material/Box'
import WestIcon from '@mui/icons-material/West'
import EastIcon from '@mui/icons-material/East'
import { ThemeProvider } from '@emotion/react'
import { defaultTheme } from '../../general/layout/ThemeProvider'
import { sideBarValues as linkItems } from '../../../data/nav/mainNav'

export default function SideBar(): React.JSX.Element {
	const [drawerOpen, setDrawerOpen] = useState(false)

	const navigate = useNavigate()
	const location = useLocation()

	const handleDrawerToggle = () => {
		setDrawerOpen(!drawerOpen)
	}

	const handleItemClick = (index: number, link: string) => {
		navigate(link)
	}

	useEffect(() => {
		// Select current item based on location
		linkItems.find(
			item => location.pathname === item.link || (item.link !== '/' && location.pathname.startsWith(item.link)),
		)
	}, [])

	return (
		<ThemeProvider theme={defaultTheme}>
			<Drawer
				variant='permanent'
				open={drawerOpen}
				transitionDuration={750}
				PaperProps={{
					sx: {
						position: 'relative',
						overflow: 'visible',
						marginBottom: '10px',
						paddingTop: '16px',
						// paddingInline: '8px',
						bgcolor: 'var(--primary-dark)',
						border: 'none',
						boxSizing: 'border-box',
						boxShadow: '2px 0 8px 0 rgba(0,0,0,0.08)', // sombra mais visível
						top: '0px',
						zIndex: theme => theme.zIndex.drawer,
						borderRadius: '19px',
					},
				}}
			>
				{/* Botão de seta */}
				<IconButton
					onClick={handleDrawerToggle}
					sx={{
						position: 'absolute',
						right: '-10px',
						top: '12px',
						zIndex: 9,
						color: 'var(--primary)',
						bgcolor: 'var(--primary-dark)',
						border: '1px solid #8695AF26',
						'&:hover': { bgcolor: '#173A5E' },
						width: '36px',
						height: '36px',
						padding: '8px',
						borderRadius: '50%',
						mb: 1,
						boxShadow: '0 2px 8px 0 rgba(0,0,0,0.10)',
					}}
				>
					{drawerOpen ? (
						<WestIcon
							sx={{ color: 'var(--primary)' }}
							fontSize='small'
						/>
					) : (
						<EastIcon
							sx={{ color: 'var(--primary)' }}
							fontSize='small'
						/>
					)}
				</IconButton>
				<List
					sx={{
						padding: 'var(--4, 32px) 0px 0px 0px',
						height: 'fit-content',
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'flex-start',
						alignSelf: 'stretch',
					}}
				>
					{/* Ícones do menu */}
					{linkItems.map(item => (
						<ListItem
							key={item.option}
							sx={{ padding: drawerOpen ? '8px 16px 8px 8px' : '8px' }}
							disablePadding
						>
							<Box>
								<div
									style={{
										display: 'flex',
										alignItems: 'center',
										gap: '16px',
										cursor: 'pointer',
									}}
									onClick={() => handleItemClick(item.option, item.link)}
								>
									<Tooltip
										title={!drawerOpen ? item.title : ''}
										placement='right'
										arrow
										slotProps={{
											tooltip: {
												sx: {
													fontSize: '16px',
													fontWeight: 500,
													backgroundColor: '#333',
													color: '#fff',
													borderRadius: '6px',
												},
											},
										}}
									>
										<ListItemIcon
											sx={{
												minWidth: 0,
												color: '#fff',
												mx: 0.5,
												display: 'flex',
												alignItems: 'center',
												width: 36,
												height: 36,
												padding: '8px',
												justifyContent: 'center',
												borderRadius: '50%',
												...(location.pathname === item.link ||
												(location.pathname.includes(item.link) && item.link !== '/')
													? { backgroundColor: 'var(--primary)' }
													: {}),
											}}
										>
											{item.icon}
										</ListItemIcon>
									</Tooltip>
									{drawerOpen && (
										<Fade
											in={drawerOpen}
											timeout={1000}
										>
											<ListItemText
												primary={item.title}
												sx={{
													color: '#fff',
													ml: 0.5,
													'.MuiListItemText-primary': { width: '100%', fontSize: '12px', fontWeight: 600 },
												}}
											/>
										</Fade>
									)}
								</div>
							</Box>
						</ListItem>
					))}
				</List>
			</Drawer>
		</ThemeProvider>
	)
}
